export default "__VITE_ASSET__gy9PnGdp__"